const Legal = () => {

    return <>
        <div className="pageheader">
            <h1>Legal</h1>
        </div>
        <div className="pagecontent">
            <p><a href="https://www.dol.gov/sites/dolgov/files/ofccp/regs/compliance/posters/pdf/eeopost.pdf"
                target="_blank" rel="noreferrer noopener">Equal Employment Opportunity (EEO) Notice</a></p>
            <p><a href="https://www.dol.gov/sites/dolgov/files/WHD/legacy/files/minwagep.pdf"
                target="_blank" rel="noreferrer noopener">Fair Labor Standards Act (FLSA)</a></p>
            <p><a href="https://www.dol.gov/sites/dolgov/files/WHD/legacy/files/fmlaen.pdf"
                target="_blank" rel="noreferrer noopener">Family and Medical Leave Act (FMLA)</a></p>
            <p><a href="https://www.maine.gov/labor/posters/"
                target="_blank" rel="noreferrer noopener">Maine Department of Labor Posters</a></p>
            <p><a href="https://www.mass.gov/doc/massachusetts-wage-hour-laws-poster/download"
                target="_blank" rel="noreferrer noopener">Massachusetts Wage &amp; Hour Laws</a></p>
            <p><a href="https://www.dli.mn.gov/sites/default/files/pdf/minimum_wage.pdf"
                target="_blank" rel="noreferrer noopener">Minnesota's Minimum Wage Laws</a></p>
        </div>
    </>;
};

export { Legal };